<template>
  <div class="donor-mails">
    <b-button class="float-right" @click="editRow(-1)" right size="sm" variant="primary">
      <font-awesome-icon icon="plus" />{{ $t('Добавить') }}
    </b-button>
    <table class="table-striped table mb-0 dx-g-bs4-overflow-hidden dx-g-bs4-table">
      <thead>
        <tr>
          <th class="edit-cell" v-if="!isReadonly"></th>
          <th>Email</th>
          <th class="delete-cell" v-if="!isReadonly"></th>
        </tr>
      </thead>
      <tbody>
        <template v-if="data && data.length > 0">
          <tr v-for="(row, index) in data" :key="'mail-row-' + index + '-' + renderKey">
            <td v-if="!isReadonly">
              <a class="edit" @click="editRow(index)" href="javascript:void(0)">
                <i class="fa fa-pencil-alt"></i>
              </a>
            </td>
            <td>{{ row.value }}</td>
            <td v-if="!isReadonly">
              <a class="delete" @click="deleteRow(data, index)" href="javascript:void(0)">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td :colspan="!isReadonly ? 3 : 1" class="text-center">Нет данных</td>
          </tr>
        </template>
      </tbody>
    </table>
    <b-modal id="edit-mail-modal"
            :title="$t('E-mail донора')"
            :no-close-on-backdrop="true"
            @keydown.native.enter="save"
            :cancel-disabled="false">
                <rdkm-input
                  :label="$t('E-Mail')"
                  v-model="row.value"
                  :name="'mail'"
                  :cols="8"
                  validate="required|email|max:100"
                  :labelCols="3"
                ></rdkm-input>
    <div slot="modal-footer" class="w-100">
      <div class="offset-md-3">
          <b-button :disabled="errors.any()" @click="save" size="sm" variant="primary" class="mr-1">
              <font-awesome-icon icon="check" /> {{ $t('Сохранить') }}
          </b-button>
          <b-button @click="hideModal('edit-mail-modal')" size="sm" variant="default">
              <font-awesome-icon icon="times" /> {{ $t('Отмена') }}
          </b-button>
        </div>
        <div class="clearfix"></div>
      </div> 
    </b-modal>
  </div>
</template>

<script>

import GridMixin from '@/components/grid/Grid.mixin';
import ModalMixin from '@/mixins/modal.mixin';
import axios from 'axios';
import Swal from 'sweetalert2';
import { EventBus } from "@/event-bus";

export default {
name: "DonorMails",
mixins: [GridMixin, ModalMixin],
props: ["id","data", "isReadonly"],
provide() {
  return {
    parentValidator: this.$validator,
  };
},
isMailHostValid: {
    validate(value, args) {
      return axios.get('/pmdd/donorsForm/isMailHostValid?mail=' + value)
      .then((response) => {
        return !response;
      })
        .catch(() => {});
    },
  },
data() {
  return {
    row: {},
    initRow: { value: '', donor_id: "" },
    currentIndex: -1,
    renderKey: 0,
  };
},
methods: {
  editRow(index) {
    this.row =  Object.assign({}, index >= 0 ? this.data[index] : this.initRow);
    this.currentIndex = index;
    this.showModal('edit-mail-modal');
  },
  save() {
    let self = this;
    this.$validator.validateAll().then((result) => {
      if(result) {
        EventBus.$emit("showThrobber");
        axios.get('/pmdd/donorsForm/isMailHostValid?mail=' + this.row.value)
        .then((response) => {
          if(response.data) {
            self.row.donor_id = self.id;
            if(self.currentIndex >= 0) {
              self.data[self.currentIndex] = self.row;
            } else {
              self.data.push(self.row);
            }
            self.renderKey++;
            self.hideModal('edit-mail-modal');
          } else {
            Swal(this.$t('Ошибка'), "Проверьте корректность домена, похоже что E-Mail не корректный!", 'warning');
          }
          EventBus.$emit("hideThrobber");
        });
      }
    });
  }
}
};
</script>
